export default __webpack_public_path__ + "static/contact-1ca81126c0165e506cf7c9b683bf097a.svg";